module.exports = __webpack_public_path__ + "static/logo-cd637aebf1cc2f0d3b3a3df9cba25bad.png";